import api from '../../../services/api';

export const settingsRoomService = {
  getRooms: async () => {
    try {
      const response = await api.get('/settings-rooms');
      return response.data;
    } catch (error) {
      console.error('Error fetching rooms:', error);
      throw error;
    }
  },

  createRoom: async (roomData) => {
    try {
      const response = await api.post('/settings-rooms', roomData);
      return response.data;
    } catch (error) {
      console.error('Error creating room:', error);
      throw error;
    }
  },

  updateRoom: async (id, roomData) => {
    try {
      const response = await api.put(`/settings-rooms/${id}`, roomData);
      return response.data;
    } catch (error) {
      console.error('Error updating room:', error);
      throw error;
    }
  }
};
